import frCA from './intl/fr-CA';
import enUS from './intl/en-US';
import enCA from './intl/en-CA';

const DEFAULT_KEY = 'en-US';

const key_lookup = {
  en: 'en-US',
  'en-US': 'en-US',
  'en-CA': 'en-CA',
  fr: 'fr-CA',
  'fr-CA': 'fr-CA'
};

const message_lookup = {
  'en-US': enUS,
  'en-CA': enCA,
  'fr-CA': frCA
};

const messages = (locale) => {
  return message_lookup[key_lookup[locale] || DEFAULT_KEY];
};

export { messages };
